import { render, staticRenderFns } from "./ChangeUserData.vue?vue&type=template&id=18903f0d&scoped=true&"
import script from "./ChangeUserData.vue?vue&type=script&lang=js&"
export * from "./ChangeUserData.vue?vue&type=script&lang=js&"
import style0 from "./ChangeUserData.vue?vue&type=style&index=0&id=18903f0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18903f0d",
  null
  
)

/* custom blocks */
import block0 from "./ChangeUserData.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18903f0d')) {
      api.createRecord('18903f0d', component.options)
    } else {
      api.reload('18903f0d', component.options)
    }
    module.hot.accept("./ChangeUserData.vue?vue&type=template&id=18903f0d&scoped=true&", function () {
      api.rerender('18903f0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user-profile/ChangeUserData.vue"
export default component.exports